import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { IbMmbConfirmationComponent } from "./ib-mmb-confirmation.component";
import { AJSCurrencyServiceProvider } from "ib-web-commons/utils";
import { AJSMmBDigitalDataServiceProvider } from "../services/ib-MmB-datalayer/services/ib-mmb-digital-data-bridge.service";
import { SharedModule } from "@src/app/shared/shared.module";
import { IbCPipeModule } from "ib-web-commons/pipes";
import { MmbConfirmationTransformer } from "./services/ib-mmb-confirmation-transformer";
import { DatalayerEcommerceService } from "../services/ib-MmB-datalayer/services/ib-mmb-datalayer-ecommerce.service";
import { MarketingPermissionService } from "./services/ib-marketing-permission-service";
import { AJSCommonsGenericProxyProvider, AJSCommonsNewHttpUtilsErrorProvider } from "../services/http/commons-proxy-bridge.service";

const downgradedComponents = [
];

@NgModule({
    declarations: [
        IbMmbConfirmationComponent
	],
	imports: [
		CommonModule,
		TranslateModule,
        SharedModule,
        IbCPipeModule
    ],
	providers: [
        AJSCurrencyServiceProvider,
        AJSMmBDigitalDataServiceProvider,
        MmbConfirmationTransformer,
        DatalayerEcommerceService,
        MarketingPermissionService,
        AJSCommonsGenericProxyProvider,
        AJSCommonsNewHttpUtilsErrorProvider
	],
    exports: []
})

export class IbMmbConfirmationModule {
	static components = [...downgradedComponents];
}
